import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "fixed-center text-center q-pa-md" };
const _hoisted_2 = { class: "text-h5 q-mt-none q-mb-md" };
const _hoisted_3 = {
    class: "text-body1 text-grey-7 q-mb-lg",
    style: { "max-width": "600px" }
};
const _hoisted_4 = { class: "row wrap justify-center q-gutter-md" };
const _hoisted_5 = {
    href: "mailto:support@iotorq-lean.com?subject=No%20Modules%20Enabled",
    style: { "text-decoration": "none" }
};
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
export default /*@__PURE__*/ _defineComponent({
    __name: 'NoModulesEnabled',
    setup(__props) {
        const { t } = useI18n();
        const router = useRouter();
        const goToFacilities = () => {
            router.push({ name: 'facility_list' });
        };
        return (_ctx, _cache) => {
            const _component_q_icon = _resolveComponent("q-icon");
            const _component_q_btn = _resolveComponent("q-btn");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_q_icon, {
                    name: "fas fa-module",
                    size: "120px",
                    color: "grey-6",
                    class: "q-mb-lg"
                }),
                _createElementVNode("h5", _hoisted_2, _toDisplayString(_unref(t)('No Modules Enabled')), 1),
                _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(t)('This tenant does not have any modules enabled. Please contact support to enable the necessary modules or check with your administrator.')), 1),
                _createElementVNode("div", _hoisted_4, [
                    _createVNode(_component_q_btn, {
                        color: "primary",
                        outline: "",
                        style: { "min-width": "200px" },
                        onClick: goToFacilities,
                        label: _unref(t)('Back to Facilities')
                    }, null, 8, ["label"]),
                    _createElementVNode("a", _hoisted_5, [
                        _createVNode(_component_q_btn, {
                            color: "secondary",
                            style: { "min-width": "200px" },
                            label: _unref(t)('Contact Support'),
                            icon: "fas fa-envelope"
                        }, null, 8, ["label"])
                    ])
                ])
            ]));
        };
    }
});
